import MerchantDcsApi from '@/api/merchant/dcs'
import Config from '@/config'

const state = {
  data: null,
  fetched: false,
  fetching: false,
  error: null,
}

const getters = {
  dcsData: (state) => {
    return state.data || null
  },
  isFetching: (state) => {
    return state.fetching
  },
  isFetched: (state) => {
    return state.fetched
  },
  hasError: (state) => {
    return state.error !== null
  },
}

const mutations = {
  SET_STATUS(state, { key, value }) {
    state[key] = value
  },
  SET_DCS_DATA(state, data) {
    state.data = data
  },
  SET_DCS_ERROR(state, error) {
    state.error = error
  },
  RESET_DCS(state) {
    state.data = null
    state.fetched = false
    state.fetching = false
    state.error = null
  },
}

const actions = {
  async fetchDcs({ commit }) {
    if (Config.isSandbox) {
      commit('SET_STATUS', { key: 'fetched', value: true })
      return
    }

    try {
      commit('SET_STATUS', { key: 'fetching', value: true })
      commit('SET_DCS_ERROR', null)

      const { data } = await MerchantDcsApi.fetchDcs()
      const { data: caseList } = data

      if (caseList.length > 0) {
        const { caseDetails } = caseList[0]
        const { data: allDetails } = await MerchantDcsApi.fetchCaseDetails(
          caseDetails.id
        )
        commit('SET_DCS_DATA', allDetails)
      }

      commit('SET_STATUS', { key: 'fetched', value: true })
      commit('SET_STATUS', { key: 'fetching', value: false })
    } catch (error) {
      commit('SET_DCS_ERROR', error)
      commit('SET_STATUS', { key: 'fetching', value: false })
      throw error
    }
  },
  resetDcs({ commit }) {
    commit('RESET_DCS')
  },
}

export default { namespaced: true, state, getters, mutations, actions }
